import { useEffect } from 'react';
import { useNavigationContext } from '../../../contexts/NavigationContext';
import './JeuneDargentre.scss';
import { useAccountContext } from '../../../contexts/AccountContext';
import { privateFetch } from '../../../utils/apiHelper';
import { useState } from 'react';
import SectionPage from './section/SectionPage';
import MainLayout from '../../../components/Display/MainLayout';


function Home() {
  const { navigationContext } = useNavigationContext();
  const { accountContext } = useAccountContext();
  const [sectionList, setSectionList] = useState([]);

  const fetchSectionList = async () => {
    await privateFetch('GET', 'jeunedargentre', `/cu/${accountContext.id}/section/`).then((res) => {
      setSectionList(res);
    });
  };

  useEffect(() => {
    fetchSectionList();
  }, []);

  return (

    <MainLayout scope={'jeunedargentre'} websiteLabel={"jeunesargentre.fr"}>
      {sectionList.map((section) => (
        <SectionPage
          isActive={navigationContext.activeAppKey === section.slug}
          section={section}
        />
      ))}
    </MainLayout>
  );
}

export default Home;
